// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconSocialMediaTwitter_loader__2pbQC","root":"IconSocialMediaTwitter_root__24iXV"};